import qs from 'qs';
import AxiosInstanceCreator from '../services/api';
import { ptwApi } from '../api/ptw.api.ts';
import moment from 'moment';
const authInstance = new AxiosInstanceCreator().create();
/*const { callAsync, showAlarm, closeAlarm } = useAsync();*/

export const dateUtil = {
  dateByMonth: (addMonth: number, date?: Date) => {
    const base = date ? new Date(date) : new Date();
    const moved = new Date(base);
    moved.setMonth(moved.getMonth() + addMonth);
    return moved;
  },
  dateByDay: (addDay: number, date?: Date) => {
    const base = date ? new Date(date) : new Date();
    const moved = new Date(base);
    moved.setDate(moved.getDate() + addDay);
    return moved;
  },

  /*addMonth 만큼 월을 이동한 날짜의 00:00:00.000 시각을 반환*/
  dateByMonthStart: (addMonth: number, date?: Date) => {
    const d = dateUtil.dateByMonth(addMonth, date);
    d.setHours(0, 0, 0, 0);
    return d;
  },

  /*addMonth 만큼 월을 이동한 날짜의 23:59:59.999 시각을 반환*/
  dateByMonthEnd: (addMonth: number, date?: Date) => {
    const d = dateUtil.dateByMonth(addMonth, date);
    d.setHours(23, 59, 59, 999);
    return d;
  },
  parse(timeStr: string, format?: string) {
    if (timeStr) {
      return new Date(timeStr);
    } else {
      return null;
    }
  },
  format(date: Date | null, format?: string) {
    if (date) {
      const year = date.getFullYear();
      const month = dateUtil.leftPad(date.getMonth() + 1);
      const day = dateUtil.leftPad(date.getDate());

      return [year, month, day].join('-');
    } else {
      return null;
    }
  },
  leftPad(value: number) {
    if (value >= 10) {
      return value;
    }
    return `0${value}`;
  },
  formatKST(date: any) {
    const pad = (n: any, l = 2) => String(n).padStart(l, '0');

    return (
      `${date.getFullYear()}-` +
      `${pad(date.getMonth() + 1)}-` +
      `${pad(date.getDate())}T` +
      `${pad(date.getHours())}:` +
      `${pad(date.getMinutes())}:` +
      `${pad(date.getSeconds())}.` +
      `${pad(date.getMilliseconds(), 3)}+0900`
    );
  },
  getTodayMorning7() {
    const d = new Date();
    d.setHours(7, 0, 0, 0);
    return d;
  },
  getTodayAfternoon19() {
    const d = new Date();
    d.setHours(19, 0, 0, 0);
    return d;
  },
  getThisSunday19() {
    const d = new Date();
    const day = d.getDay(); // 0 = Sunday
    const diffToSunday = (7 - day) % 7;

    d.setDate(d.getDate() + diffToSunday);
    d.setHours(19, 0, 0, 0);

    return formatKST(d);
  },
  getAfterMonth19() {
    const d = new Date();
    d.setMonth(d.getMonth() + 1);
    d.setHours(19, 0, 0, 0);
    return d;
  },
  getThisWeekMonday7AM() {
    const d = new Date();

    const day = d.getDay();
    const diffToMonday = day === 0 ? -6 : 1 - day;

    d.setDate(d.getDate() + diffToMonday);
    d.setHours(7, 0, 0, 0);

    return formatKST(d);
  },
  getTodayMidnight() {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  },
  getThisWeekMondayMidnight() {
    const d = new Date();
    const day = d.getDay();
    const diffToMonday = day === 0 ? -6 : 1 - day;
    d.setDate(d.getDate() + diffToMonday);
    d.setHours(0, 0, 0, 0);
    return formatKST(d);
  },
  getThisSundayMidnight() {
    const d = new Date();
    const day = d.getDay();
    const diffToSunday = (7 - day) % 7;
    d.setDate(d.getDate() + diffToSunday);
    d.setHours(0, 0, 0, 0);
    return formatKST(d);
  },
  getAfterMonthMidnight() {
    const d = new Date();
    d.setMonth(d.getMonth() + 1);
    d.setHours(0, 0, 0, 0);
    return d;
  },
  toOffsetString(d?: Date | null) {
    return d ? moment(d).format('YYYY-MM-DDTHH:mm:ss.SSSZ') : null;
  },
  formatDate(input: Date) {
    if (!input) return '';

    let date;

    if (input instanceof Date) {
      date = input;
    } else if (typeof input === 'string') {
      date = new Date(input);
    } else {
      return '';
    }

    if (isNaN(date.getTime())) return '';

    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ];

    const day = String(date.getDate()).padStart(2, '0');
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    const hour = String(date.getHours()).padStart(2, '0');
    const minute = String(date.getMinutes()).padStart(2, '0');
    const second = String(date.getSeconds()).padStart(2, '0');

    return `${day}-${month}-${year} ${hour}:${minute}:${second}`;
  }
};

export const systemCdUtil = {
  async getOptions(clsCd: string): Promise<{ value: string; label: string }[]> {
    const result = await authInstance.get(`/global/systemCd/getSystemCdList?clsCd=${clsCd}`);
    return (Array.isArray(result.data.resultList) ? result.data.resultList : [])
      .filter((r: any) => r?.systemId != null && r?.cdNm != null)
      .map((r: any) => ({ value: String(r.systemId), label: String(r.cdNm) }));
  }
};

export const companyUtil = {
  async getOptions(): Promise<{ value: string; label: string }[]> {
    const result = await authInstance.get(`/global/company/getCompanyList`);
    return (Array.isArray(result.data.resultList) ? result.data.resultList : [])
      .filter((r: any) => r?.companyId != null && r?.companyName != null)
      .map((r: any) => ({ value: String(r.companyId), label: String(r.companyName) }));
  }
};

export const formDataUtil = {
  append: (fd: FormData, key: string, value: unknown) => {
    if (value === null || value === undefined) {
      fd.delete(key);
      return;
    }
    fd.append(key, typeof value === 'string' ? value : String(value));
  }
};

export const commonMsg = {
  alert: (showAlarm: any, closeAlarm: any, title: string, msg: any, closeAction?: any) => {
    showAlarm({
      modalTitle: title,
      message: msg,
      isSingleFooter: true,
      noFooter: false,
      closeButtonProps: {
        onClick: () => {
          if (closeAction) {
            closeAction();
          }
          closeAlarm();
        }
      }
    });
  },
  confirm: (showAlarm: any, closeAlarm: any, title: string, msg: any, okAction: any) => {
    showAlarm({
      modalTitle: title,
      message: msg,
      noFooter: false,
      okButtonProps: {
        children: 'OK',
        onClick: () => {
          okAction();
          closeAlarm();
        }
      },
      closeButtonProps: {
        onClick: closeAlarm
      }
    });
  }
};
export const formatKST = (date: any) => {
  const pad = (n: any, l = 2) => String(n).padStart(l, '0');

  return (
    `${date.getFullYear()}-` +
    `${pad(date.getMonth() + 1)}-` +
    `${pad(date.getDate())}T` +
    `${pad(date.getHours())}:` +
    `${pad(date.getMinutes())}:` +
    `${pad(date.getSeconds())}.` +
    `${pad(date.getMilliseconds(), 3)}+0900`
  );
};
export const format = (date: any) => {
  const pad = (n: any, l = 2) => String(n).padStart(l, '0');

  return (
    `${date.getFullYear()}-` +
    `${pad(date.getMonth() + 1)}-` +
    `${pad(date.getDate())}T` +
    `${pad(date.getHours())}:` +
    `${pad(date.getMinutes())}`
  );
};
